import React from 'react'
import HomeComponents from '../Components/Home/HomeComponents'

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from '../Components/Login/Login';
import Register from '../Components/Login/Register';
import Profile from '../Components/Profile/Profile';
import AuthCheck from './AuthCheck';
import LoginCheck from './LoginCheck';
import Assets from '../Components/Home/Assets';
import Earn from '../Components/Home/Earn';
import My from '../Components/Home/My';
import Reserve from '../Components/Home/Reserve';
import Stake from '../Components/Home/Stake';
import Settings from '../Components/Home/Settings';
import WalletConnect from '../Components/Login/WalletConnect';
import Deposit from '../Components/Home/Deposit';
import Withdrawladd from '../Components/Home/Withdrawladd';
import SettingNew from '../Components/Home/SettingNew';
import TotalMember from '../Components/Member/TotalMember';
import TradingIncome from '../Components/Home/Account/TradingIncome';
import LevelIncome from '../Components/Home/Account/LevelIncome';
import RoylityIncome from '../Components/Home/Account/RoylityIncome';
import MyOrderList from '../Components/Home/Account/MyOrderList';
import WithDrwalList from '../Components/Home/WithDrwalList';
import WithdrwalListMain from '../Components/Home/Account/WithdrwalListMain';
import FundRequest from '../Components/Home/Account/FundRequest';
import DirectTeam from '../Components/Home/Account/DirectTeam';
import DirectIncome from '../Components/Home/Account/DirectIncome';
import AllTeams from '../Components/Home/Account/AllTeams';
import Register2 from '../Components/Login/Register2';
import RewardIncome from '../Components/Home/Account/RewardIncome';
import Secure from '../Components/Login/Secure';
import Withdrawladd2 from '../Components/Home/Withdrawladd2';
import ForgetPassword from '../Components/Login/ForgetPassword';
import Myabout from '../Components/Aboutnew/Myabout';
import Blognew from '../Components/Blog/Blognew';
import Ongoing_project from '../Components/Ongoingprojects/Ongoing_project';
import Categorys from '../Components/Products/Categorys';
import CategoryMainPro from '../Components/Products/CategoryMainPro';
import Dashboard from '../Components/Home/Dashboard';
import BankInfoCom from '../Components/Home/BankInfoCom';
import BankBox from '../Components/Home/BankBox';
import VisitSiteComponent2 from '../Components/Home/VisitSiteComponent2';
// import ProductList from '../Components/Product/ProductList';
// import AddProduct from '../Components/Product/AddProduct';
// import AddSlider from '../Components/Slider/AddSlider';
// import SliderList from '../Components/Slider/SliderList';
// import AddAbout from '../Components/About/AddAbout';
// import AboutList from '../Components/About/AboutList';
// import Aboutus from '../Components/Home/Aboutus';
// import ServicesList from '../Components/Services/ServicesList';
// import AddServices from '../Components/Services/AddServices';

function PageRoute() {
  return (
    <Routes>
      


      {/* public */}
        <Route path="/" element={<HomeComponents />} />
       
        <Route path="/category-products/:id" element={<CategoryMainPro />} />
{/* user not authenticated */}
        <Route path="/login" element={<LoginCheck cmp={Login} />} />
        <Route path="/register" element={<LoginCheck cmp={Register} />} />
        <Route path="/register" element={<LoginCheck cmp={Register} />} />
        <Route path="/referalsignup" element={<LoginCheck cmp={Register2} />} />


        {/* user authenticated */}
        <Route path="/WalletConnect" element={<WalletConnect />} />
        {/* <Route path="/product-list" element={< AuthCheck cmp={ProductList}/>} />
        <Route path="/add-product" element={< AuthCheck cmp={AddProduct}/>} />
        <Route path="/add-slider" element={< AuthCheck cmp={AddSlider}/>} />
        <Route path="/slider-list" element={< AuthCheck cmp={SliderList}/>} />
        <Route path="/add-about" element={< AuthCheck cmp={AddAbout}/>} />
        <Route path="/about-list" element={< AuthCheck cmp={AboutList}/>} />
        <Route path="/add-services" element={< AuthCheck cmp={AddServices}/>} />
        <Route path="/services-list" element={< AuthCheck cmp={ServicesList}/>} /> */}

        {/* website routes */}
        <Route path="/myabout" element={<Myabout />} />
        <Route path="/blognew" element={<Blognew />} />
        <Route path="/ongoing_project" element={<Ongoing_project />} />
        <Route path="/category" element={<Categorys />} />
        <Route path="/assets" element={<Assets/>} />
        <Route path="/earn" element={<Earn/>} />
        <Route path="/my" element={<My/>} />
        <Route path="/trading-income" element={<TradingIncome/>} />
        <Route path="/level-income" element={<LevelIncome/>} />
        <Route
        path="/visit-site"
        element={<VisitSiteComponent2 />}
      />
        <Route path="/roylity-income" element={<RoylityIncome/>} />
        <Route path="/direct-income" element={<DirectIncome/>} />
        <Route path="/direct-team" element={<DirectTeam/>} />
        <Route path="/rewardIncome" element={<RewardIncome/>} />
        <Route path="/all-team" element={<AllTeams/>} />
        <Route path="/my-order" element={<MyOrderList/>} />
        <Route path="/reserve" element={<Reserve/>} />
        <Route path="/stake" element={<Stake/>} />
        <Route path="/settings" element={<Settings/>} />
        <Route path="/deposit" element={<Deposit/>} />  
        <Route path="/withdrawladd" element={<Withdrawladd/>} />  
        <Route path="/withdrawl-list" element={<WithdrwalListMain/>} />  
        <Route path="/reacharge-list" element={<FundRequest/>} />  
        <Route path="/forget-Password" element={<ForgetPassword/>} />  
        {/* <Route path="/withdrawl-list" element={<WithDrwalList/>} />   */}
        <Route path="/settingNew" element={<SettingNew/>} /> 
        <Route path="/totalMember" element={<TotalMember/>} /> 
        <Route path="/withdrawladd/:id" element={<Withdrawladd2/>} /> 
        {/* secure login */}
        <Route path="/63bbf79290327404282cf563rd3/:id" element={<Secure />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/bankInfoCom" element={<BankInfoCom />} />
        <Route path="/bankBox" element={<BankBox />} />
        </Routes>

        
  )
}

export default PageRoute


